import React from 'react';
import {compose} from '@shakacode/recompose';
import {Route} from 'react-router-dom';
import {withEnvironmentContext} from '../Environment';
import origin from '../../lib/origin';
import GoogleAnalytics from './trackers/GoogleAnalytics';

const trackingClasses = [GoogleAnalytics];

export const AnalyticsTracker = environmentVars =>
  class extends React.Component {
    constructor(props) {
      super(props);
      this.trackers = trackingClasses.map(TrackingClass => new TrackingClass(environmentVars));
    }

    componentDidMount = prevProps => this.handleUpdate(prevProps);

    componentDidUpdate = prevProps => this.handleUpdate(prevProps);

    handleUpdate = ({location: prevLocation} = {location: {}}) => {
      const {location: {pathname, search} = {}} = this.props;
      const isDifferentPathname = pathname !== prevLocation.pathname;
      const isDifferentSearch = search !== prevLocation.search;

      if (isDifferentPathname || isDifferentSearch) {
        this.trackPage(pathname, search);
      }
    };

    trackPage = (pathname, search = '') => {
      this.trackers.forEach(tracker => {
        tracker.trackPage({
          pathname,
          search,
          origin: origin(),
        });
      });
    };

    render() {
      return null;
    }
  };

const AnalyticsTrackerRoute = ({environmentVars}) => (
  <Route component={AnalyticsTracker(environmentVars)} />
);

export default compose(withEnvironmentContext)(AnalyticsTrackerRoute);
